module.exports = __webpack_public_path__ + "img/search.42458369.jpg";